import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 160 160"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#03DAC4",
  "fill-rule": "evenodd",
  d: "M50.613 20.767a2.996 2.996 0 0 1 4.107 1.042l7.918 13.296 3.522-15.07a2.996 2.996 0 0 1 5.492-.85L79.57 32.48l3.521-15.07a2.996 2.996 0 0 1 5.836 1.365l-5.213 22.303a2.996 2.996 0 0 1-5.492.852l-7.918-13.297-3.522 15.07a2.996 2.996 0 0 1-5.492.85l-11.719-19.68a2.996 2.996 0 0 1 1.042-4.107ZM133.275 44.55a2.996 2.996 0 0 1-.467 4.211l-12.081 9.671 15.41 1.416a2.997 2.997 0 0 1 1.599 5.323l-12.081 9.67 15.41 1.417a2.995 2.995 0 1 1-.549 5.967l-22.808-2.096a2.997 2.997 0 0 1-1.598-5.322l12.081-9.671-15.411-1.416a2.995 2.995 0 0 1-1.598-5.323l17.881-14.314a2.997 2.997 0 0 1 4.212.467ZM110.98 30.07c-3.522-2.853-8.699-2.31-11.563 1.227-2.863 3.536-2.318 8.713 1.204 11.565 3.531 2.86 8.733 2.321 11.589-1.206s2.301-8.727-1.23-11.587Zm-16.22-2.545c4.941-6.1 13.891-7.053 19.991-2.113 6.092 4.933 7.065 13.905 2.116 20.015-4.948 6.111-13.926 7.025-20.017 2.092-6.101-4.94-7.03-13.892-2.09-19.994ZM139.126 94.812a2.996 2.996 0 0 1 1.524 3.954l-7.245 16.345a2.998 2.998 0 0 1-5.432.099l-9.351-19.167-4.637 10.459a2.996 2.996 0 0 1-5.478-2.429l7.245-16.345a2.998 2.998 0 0 1 5.432-.099l9.352 19.167 4.636-10.459a2.997 2.997 0 0 1 3.954-1.525ZM121.672 130.772a2.996 2.996 0 0 1-4.232.211l-16.283-14.736a2.996 2.996 0 0 1 4.021-4.443l16.283 14.735a2.997 2.997 0 0 1 .211 4.233Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#03DAC4",
  "fill-rule": "evenodd",
  d: "M25.267 80.697c6.474-1.572 12.936 2.344 14.434 8.748 1.773 7.582 5.742 14.467 11.365 19.751 4.607 4.329 10.333 7.594 16.934 9.308a39.71 39.71 0 0 0 18.158.439c6.52-1.362 12.846 2.764 14.131 9.215 1.286 6.451-2.957 12.785-9.476 14.147a63.922 63.922 0 0 1-29.195-.696c-10.565-2.743-19.802-8.002-27.22-14.972a62.889 62.889 0 0 1-18.14-31.5c-1.498-6.402 2.536-12.868 9.01-14.44Z",
  "clip-rule": "evenodd",
  opacity: ".7"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#02CAF2",
  "fill-rule": "evenodd",
  d: "M47.7 36.653c4.992 4.284 5.485 11.82 1.1 16.832a40.929 40.929 0 0 0-8.66 16.104c-1.873 6.778-1.912 13.56-.44 19.856 1.774 7.582 5.743 14.467 11.366 19.751 4.792 4.503 4.946 12.058.343 16.874-4.602 4.816-12.219 5.07-17.01.567a62.889 62.889 0 0 1-18.141-31.499c-2.353-10.06-2.276-20.87.68-31.573A65.142 65.142 0 0 1 30.72 37.971c4.385-5.012 11.986-5.602 16.98-1.318Z",
  "clip-rule": "evenodd",
  opacity: ".7"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }